<template>
  <a
    v-if="to"
    :disabled="disabled"
    :href="to"
    target="_blank"
    class="py-1 px-5 md:px-10 flex justify-center items-center transition-colors duration-300 ease-in-out"
    :class="{
      'cursor-pointer': !disabled,
      'cursor-not-allowed': disabled,
      'border border-white ': bordered && type === 'primary',
      'border border-black hover:bg-black hover:text-white': bordered && type === 'default',
      'bg-black': type === 'primary',
      'text-white': type === 'primary',
      'opacity-20 hover:bg-white hover:text-black': disabled,
    }"
  >
    <span v-if="$slots['icon-left']" class="w-4 h-4 ml-2">
      <slot name="icon-left" />
    </span>
    <span class="mx-2 text-base">
      <slot></slot>
    </span>
    <span v-if="$slots['icon-right']" class="w-4 h-4 mr-2">
      <slot name="icon-right" />
    </span>
  </a>
  <button
    v-else
    :disabled="disabled"
    class="py-1 px-5 md:px-10 flex justify-center items-center transition-colors duration-300 ease-in-out"
    :class="{
      'cursor-pointer': !disabled,
      'cursor-not-allowed': disabled,
      'border border-white': bordered && type === 'primary',
      'border border-black hover:bg-black hover:text-white': bordered && type === 'default',
      'bg-black ': type === 'primary',
      'text-white': type === 'primary',
      'opacity-20 hover:bg-white hover:text-black': disabled,
    }"
  >
    <span v-if="$slots['icon-left']" class="w-4 h-4 ml-2">
      <slot name="icon-left" />
    </span>
    <span class="mx-2 text-base">
      <slot></slot>
    </span>
    <span v-if="$slots['icon-right']" class="w-4 h-4 mr-2">
      <slot name="icon-right" />
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  // TODO: Use Enums for available states/styles?
  props: {
    type: { type: String, default: 'default' },
    bordered: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    to: { type: String, default: '' },
  },
})
</script>

<style scoped></style>
